import React from "react";
import { Container } from "../app.style";

const ImpressumScreen = () => {
  return (
    <main>
      <section>
        <Container>
          <h1>Impressum</h1>
          <p>
            AB | Web Design & Development <br />
            Andreas Bonke
            <br />
            Am Krusenick 6 <br />
            12555 Berlin <br />
            <br />
            Tel: 0152 24307024
            <br />
            Email: mail@andreasbonke.de <br />
            <br />
            Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine
            Garantie dafür, dass die auf dieser Website bereitgestellten
            Informationen vollständig, richtig und aktuell sind. Wir behalten
            uns vor, die Informationen in dieser Site jederzeit und ohne
            vorherige Ankündigung zu ändern oder zu aktualisieren. Wir
            übernehmen keine Haftung für die Inhalte externer Links. Für den
            Inhalt verlinkter Seiten sind ausschließlich deren Betreiber
            verantwortlich. Alle auf unseren Internetseiten veröffentlichten
            Werke bzw. Werkteile wie z.B. Texte, Bilder, Illustrationen und
            Dateien unterliegen dem Urheberrecht und anderen Gesetzen zum Schutz
            geistigen Eigentums. Jede weitere Veröffentlichung,
            Vervielfältigung, Verbreitung oder sonstige Nutzung, auch
            auszugsweise, bedarf der schriftlichen Genehmigung.
          </p>
          <h1>Datenschutzbestimmungen</h1>
          <h2>ARTEN DER ERHOBENEN DATEN</h2>
          <p>
            Der Eigentümer stellt keine Auflistung der erhobenen
            personenbezogenen Daten zur Verfügung.Vollständige Details zu jeder
            Art von verarbeiteten personenbezogenen Daten werden in den dafür
            vorgesehenen Abschnitten dieser Datenschutzerklärung oder punktuell
            durch Erklärungstexte bereitgestellt, die vor der Datenerhebung
            angezeigt werden.Personenbezogene Daten können vom Nutzer freiwillig
            angegeben oder, im Falle von Nutzungsdaten, automatisch erhoben
            werden, wenn diese Anwendung genutzt wird.Sofern nicht anders
            angegeben, ist die Angabe aller durch diese Anwendung angeforderten
            Daten obligatorisch. Weigert sich der Nutzer, die Daten anzugeben,
            kann dies dazu führen, dass diese Anwendung dem Nutzer ihre Dienste
            nicht zur Verfügung stellen kann. In Fällen, in denen diese
            Anwendung die Angabe personenbezogener Daten ausdrücklich als
            freiwillig bezeichnet, dürfen sich die Nutzer dafür entscheiden,
            diese Daten ohne jegliche Folgen für die Verfügbarkeit oder die
            Funktionsfähigkeit des Dienstes nicht anzugeben.Nutzer, die sich
            darüber im Unklaren sind, welche personenbezogenen Daten
            obligatorisch sind, können sich an den Anbieter wenden.Jegliche
            Verwendung von Cookies – oder anderer Tracking-Tools – durch diese
            Anwendung oder Anbieter von Drittdiensten, die durch diese Anwendung
            eingesetzt werden, dient dem Zweck, den vom Nutzer gewünschten
            Dienst zu erbringen, und allen anderen Zwecken, die im vorliegenden
            Dokument und, falls vorhanden, in der Cookie-Richtlinie beschrieben
            sind.Die Nutzer sind für alle personenbezogenen Daten Dritter
            verantwortlich, die durch diese Anwendung beschafft, veröffentlicht
            oder weitergegeben werden, und bestätigen, dass sie die Zustimmung
            zur Übermittlung personenbezogener Daten etwaiger Dritter an diese
            Anwendung eingeholt haben.
          </p>
          <h2>ART UND ORT DER DATENVERARBEITUNG</h2>
          <h3>Verarbeitungsmethoden</h3>
          <p>
            Der Anbieter verarbeitet die Nutzerdaten auf ordnungsgemäße Weise
            und ergreift angemessene Sicherheitsmaßnahmen, um den unbefugten
            Zugriff und die unbefugte Weiterleitung, Veränderung oder
            Vernichtung von Daten zu vermeiden.Die Datenverarbeitung wird
            mittels Computern oder IT-basierten Systemen nach organisatorischen
            Verfahren und Verfahrensweisen durchgeführt, die gezielt auf die
            angegebenen Zwecke abstellen. Zusätzlich zum Verantwortlichen
            könnten auch andere Personen intern (Personalverwaltung, Vertrieb,
            Marketing, Rechtsabteilung, Systemadministratoren) oder extern – und
            in dem Fall soweit erforderlich, vom Verantwortlichen als
            Auftragsverarbeiter benannt (wie Anbieter technischer
            Dienstleistungen, Zustellunternehmen, Hosting-Anbieter,
            IT-Unternehmen oder Kommunikationsagenturen) - diese Anwendung
            betreiben und damit Zugriff auf die Daten haben. Eine aktuelle Liste
            dieser Beteiligten kann jederzeit vom Anbieter verlangt werden.
          </p>
          <h3>Rechtsgrundlagen der Verarbeitung</h3>
          <p>
            Der Anbieter darf personenbezogene Daten von Nutzern nur dann
            verarbeiten, wenn einer der folgenden Punkte zutrifft: Die Nutzer
            haben ihre Einwilligung für einen oder mehrere bestimmte Zwecke
            erteilt. Hinweis: In einigen Gesetzgebungen kann es dem Anbieter
            gestattet sein, personenbezogene Daten zu verarbeiten, bis der
            Nutzer einer solchen Verarbeitung widerspricht („Opt-out“), ohne
            sich auf die Einwilligung oder eine andere der folgenden
            Rechtsgrundlagen verlassen zu müssen. Dies gilt jedoch nicht, wenn
            die Verarbeitung personenbezogener Daten dem europäischen
            Datenschutzrecht unterliegt.Die Datenerhebung ist für die Erfüllung
            eines Vertrages mit dem Nutzer und/oder für vorvertragliche
            Maßnahmen daraus erforderlich. Die Verarbeitung ist für die
            Erfüllung einer rechtlichen Verpflichtung, der der Anbieter
            unterliegt, erforderlich. Die Verarbeitung steht im Zusammenhang mit
            einer Aufgabe, die im öffentlichen Interesse oder in Ausübung
            hoheitlicher Befugnisse, die dem Anbieter übertragen wurden,
            durchgeführt wird. Die Verarbeitung ist zur Wahrung der berechtigten
            Interessen des Anbieters oder eines Dritten erforderlich. In jedem
            Fall erteilt der Anbieter gerne Auskunft über die konkrete
            Rechtsgrundlage, auf der die Verarbeitung beruht, insbesondere
            darüber, ob die Angabe personenbezogener Daten eine gesetzliche oder
            vertragliche Verpflichtung oder eine Voraussetzung für den Abschluss
            eines Vertrages ist.
          </p>
          <h2>ORT</h2>
          <p>
            Die Daten werden in der Niederlassung des Anbieters und an allen
            anderen Orten, an denen sich die an der Datenverarbeitung
            beteiligten Stellen befinden, verarbeitet. Je nach Standort der
            Nutzer können Datenübertragungen die Übertragung der Daten des
            Nutzers in ein anderes Land als das eigene beinhalten. Um mehr über
            den Ort der Verarbeitung der übermittelten Daten zu erfahren, können
            die Nutzer den Abschnitt mit den ausführlichen Angaben zur
            Verarbeitung der personenbezogenen Daten konsultieren.Die Nutzer
            haben auch das Recht, sich über die Rechtsgrundlage der
            Datenübermittlung in ein Land außerhalb der Europäischen Union oder
            an eine internationale Organisation, die dem Völkerrecht unterliegt
            oder von zwei oder mehr Ländern gegründet wurde, wie beispielsweise
            die UNO, sowie sich über die vom Anbieter ergriffenen
            Sicherheitsmaßnahmen zum Schutz ihrer Daten aufklären zu lassen.
            Wenn eine solche Übermittlung stattfindet, kann der Nutzer mehr
            darüber erfahren, indem er die entsprechenden Abschnitte dieses
            Dokuments überprüft oder sich mit dem Anbieter über die im
            Kontaktteil angegebenen Informationen in Verbindung setzt.
          </p>
          <h2>SPEICHERDAUER</h2>
          <p>
            Personenbezogene Daten werden so lange verarbeitet und gespeichert,
            wie es der Zweck erfordert, zu dem sie erhoben wurden. Daher gilt:
            Personenbezogene Daten, die zu Zwecken der Erfüllung eines zwischen
            dem Anbieter und dem Nutzer geschlossenen Vertrages erhoben werden,
            werden bis zur vollständigen Erfüllung dieses Vertrages gespeichert.
            Personenbezogene Daten, die zur Wahrung der berechtigten Interessen
            des Anbieters erhoben werden, werden so lange aufbewahrt, wie es zur
            Erfüllung dieser Zwecke erforderlich ist. Nutzer können nähere
            Informationen über die berechtigten Interessen des Anbieters in den
            entsprechenden Abschnitten dieses Dokuments oder durch
            Kontaktaufnahme zum Anbieter erhalten.Darüber hinaus ist es dem
            Anbieter gestattet, personenbezogene Daten für einen längeren
            Zeitraum zu speichern, wenn der Nutzer in eine solche Verarbeitung
            eingewilligt hat, solange die Einwilligung nicht widerrufen wird.
            Darüber hinaus kann der Anbieter verpflichtet sein, personenbezogene
            Daten für einen längeren Zeitraum aufzubewahren, wenn dies zur
            Erfüllung einer gesetzlichen Verpflichtung oder auf Anordnung einer
            Behörde erforderlich ist. Nach Ablauf der Aufbewahrungsfrist werden
            personenbezogene Daten gelöscht. Daher können das Auskunftsrecht,
            das Recht auf Löschung, das Recht auf Berichtigung und das Recht auf
            Datenübertragbarkeit nach Ablauf der Aufbewahrungsfrist nicht
            geltend gemacht werden.
          </p>
          <h2>ZWECKE DER VERARBEITUNG</h2>
          <p>
            Personenbezogene Daten über den Nutzer werden erhoben, damit der
            Anbieter den Dienst erbringen und des Weiteren seinen gesetzlichen
            Verpflichtungen nachkommen, auf Durchsetzungsforderungen reagieren,
            seine Rechte und Interessen (oder die der Nutzer oder Dritter)
            schützen, böswillige oder betrügerische Aktivitäten aufdecken kann.
            Darüber hinaus werden Daten zu folgenden Zwecken erhoben:
            Plattform-Dienste und Hosting. Nutzer können im Abschnitt
            “Ausführliche Angaben über die Verarbeitung personenbezogener Daten”
            dieses Dokuments weitere detaillierte Informationen zu diesen
            Verarbeitungszwecken und die zu den für den jeweiligen Zweck
            verwendeten personenbezogenen Daten vorfinden.
          </p>
          <h2>DIE RECHTE DER NUTZER</h2>
          <p>
            Die Nutzer können bestimmte Rechte in Bezug auf ihre vom Anbieter
            verarbeiteten Daten ausüben.Nutzer haben insbesondere das Recht,
            Folgendes zu tun:
          </p>
          <p>
            Die Einwilligungen jederzeit widerrufen. Hat der Nutzer zuvor in die
            Verarbeitung personenbezogener Daten eingewilligt, so kann er die
            eigene Einwilligung jederzeit widerrufen.
          </p>
          <p>
            Widerspruch gegen die Verarbeitung ihrer Daten einlegen. Der Nutzer
            hat das Recht, der Verarbeitung seiner Daten zu widersprechen, wenn
            die Verarbeitung auf einer anderen Rechtsgrundlage als der
            Einwilligung erfolgt. Weitere Informationen hierzu sind weiter unten
            aufgeführt.
          </p>
          <p>
            Auskunft bezüglich ihrer Daten erhalten. Der Nutzer hat das Recht zu
            erfahren, ob die Daten vom Anbieter verarbeitet werden, über
            einzelne Aspekte der Verarbeitung Auskunft zu erhalten und eine
            Kopie der Daten zu erhalten.
          </p>
          <p>
            ‍Überprüfen und berichtigen lassen. Der Nutzer hat das Recht, die
            Richtigkeit seiner Daten zu überprüfen und deren Aktualisierung oder
            Berichtigung zu verlangen.
          </p>
          <p>
            Einschränkung der Verarbeitung ihrer Daten verlangen. Die Nutzer
            haben das Recht, unter bestimmten Umständen die Verarbeitung ihrer
            Daten einzuschränken. In diesem Fall wird der Anbieter die Daten zu
            keinem anderen Zweck als der Speicherung verarbeiten.
          </p>
          <p>
            Löschung oder anderweitiges Entfernen der personenbezogenen Daten
            verlangen. Die Nutzer haben unter bestimmten Umständen das Recht,
            die Löschung ihrer Daten vom Anbieter zu verlangen.
          </p>
          <p>
            Ihre Daten erhalten und an einen anderen Verantwortlichen übertragen
            lassen. Der Nutzer hat das Recht, seine Daten in einem
            strukturierten, gängigen und maschinenlesbaren Format zu erhalten
            und, sofern technisch möglich, ungehindert an einen anderen
            Verantwortlichen übermitteln zu lassen. Diese Bestimmung ist
            anwendbar, sofern die Daten automatisiert verarbeitet werden und die
            Verarbeitung auf der Zustimmung des Nutzers, auf einem Vertrag, an
            dem der Nutzer beteiligt ist, oder auf vorvertraglichen
            Verpflichtungen beruht.
          </p>
          <p>
            Beschwerde einreichen. Die Nutzer haben das Recht, eine Beschwerde
            bei der zuständigen Aufsichtsbehörde einzureichen.
          </p>
          <p>
            Details zum Widerspruchsrecht bezüglich der Verarbeitung. Werden
            personenbezogene Daten im öffentlichen Interesse, in Ausübung eines
            dem Anbieter übertragenen hoheitlichen Befugnisses oder zur Wahrung
            der berechtigten Interessen des Anbieters verarbeitet, kann der
            Nutzer dieser Verarbeitung widersprechen, indem er einen
            Rechtfertigungsgrund angibt, der sich auf seine besondere Situation
            bezieht. Nutzer werden darüber informiert, dass sie der Verarbeitung
            der personenbezogenen Daten für Direktwerbung jederzeit ohne Angabe
            von Gründen widersprechen können. Ob der Anbieter personenbezogene
            Daten für Direktwerbungszwecke verarbeitet, können die Nutzer den
            entsprechenden Abschnitten dieses Dokuments entnehmen.
          </p>
          <p>
            Wie die Rechte ausgeübt werden können. Alle Anfragen zur Ausübung
            der Nutzerrechte können über die in diesem Dokument angegebenen
            Kontaktdaten an den Anbieter gerichtet werden. Anträge können
            kostenlos ausgeübt werden und werden vom Anbieter so früh wie
            möglich, spätestens innerhalb eines Monats, bearbeitet.
          </p>
          <h2>
            WEITERE INFORMATIONEN ÜBER DIE ERHEBUNG UND VERARBEITUNG VON DATEN
          </h2>
          <h3>Rechtliche Maßnahmen</h3>
          <p>
            Die personenbezogenen Daten des Nutzers können vom Anbieter zu
            Zwecken der Rechtsdurchsetzung innerhalb oder in Vorbereitung
            gerichtlicher Verfahren verarbeitet werden, die sich daraus ergeben,
            dass diese Anwendung oder die dazugehörigen Dienste nicht
            ordnungsgemäß genutzt wurden.Der Nutzer erklärt, sich dessen bewusst
            zu sein, dass der Anbieter von den Behörden zur Herausgabe von
            personenbezogenen Daten verpflichtet werden könnte.
          </p>
          <p>
            Weitere Informationen über die personenbezogenen Daten des Nutzers
            Zusätzlich zu den in dieser Datenschutzerklärung aufgeführten
            Informationen kann diese Anwendung dem Nutzer auf Anfrage weitere
            kontextbezogene Informationen zur Verfügung stellen, die sich auf
            bestimmte Dienste oder auf die Erhebung und Verarbeitung
            personenbezogener Daten beziehen.
          </p>
          <h3>Systemprotokolle und Wartung</h3>
          <p>
            Diese Anwendung und die Dienste von Drittanbietern können zu
            Betriebs- und Wartungszwecken Dateien sammeln, die die über diese
            Anwendung stattfindende Interaktion aufzeichnen (Systemprotokolle),
            oder andere personenbezogene Daten (z. B. IP-Adresse) zu diesem
            Zweck verwenden.
          </p>
          <p>
            Nicht in dieser Datenschutzerklärung enthaltene Informationen
            Weitere Informationen über die Erhebung oder Verarbeitung
            personenbezogener Daten können jederzeit vom Anbieter über die
            aufgeführten Kontaktangaben angefordert werden.
          </p>
          <p>
            Wie „Do Not Track“ Anfragen behandelt werden Diese Anwendung
            unterstützt keine Nicht-Verfolgen-Anfragen („Do Not Track”) durch
            Webbrowser. Die Information, ob integrierte Drittdienste das
            Nicht-Verfolgen Protokoll unterstützen, entnehmen Nutzer der
            Datenschutzerklärung des jeweiligen Dienstes.
          </p>
          <h3>Änderungen dieser Datenschutzerklärung</h3>
          <p>
            Der Anbieter behält sich vor, jederzeit Änderungen an dieser
            Datenschutzerklärung vorzunehmen, indem Nutzer auf dieser Seite und
            gegebenenfalls über diese Anwendung und/oder - soweit technisch und
            rechtlich möglich – durch das Versenden einer Mitteilung über dem
            Anbieter vorliegende Kontaktdaten der Nutzer informiert werden.
            Nutzern wird daher nahe gelegt, diese Seite regelmäßig aufzurufen
            und insbesondere das am Seitenende angegebene Datum der letzten
            Änderung zu prüfen. Soweit Änderungen eine auf der Einwilligung des
            Nutzers basierte Datennutzung betreffen, so wird der Anbieter -
            soweit erforderlich - eine neue Einwilligung einholen.
          </p>
        </Container>
      </section>
    </main>
  );
};

export default ImpressumScreen;
